import { createSelector } from 'reselect';

/**
 * Get Tables from state.
 *
 * @author Mikhail Siutsou
 * @function getTables
 * @category Selectors
 * @subcategory Tables
 * @param {AppState} state state.
 * @return {TableState[]} modals state.
 */
var getTables = function getTables(state) {
  return state.tables;
};
/**
 * Get tables array.
 *
 * @author Mikhail Siutsou
 * @function getTablesSelector
 * @category Selectors
 * @subcategory Tables
 * @param {AppState} state state.
 * @return {TableState[]} modals state.
 */


export var getTablesSelector = createSelector(getTables, function (tables) {
  return tables;
});
/**
 * Get table by id.
 *
 * @author Mikhail Siutsou
 * @function getTableSelector
 * @category Selectors
 * @subcategory Tables
 * @param {AppState} state state.
 * @return {TableState['tableId'] | undefined} modals state.
 */

export var getTableSelector = function getTableSelector(tableId) {
  return createSelector(getTables, function (tables) {
    return tables.find(function (table) {
      return table.tableId === tableId;
    });
  });
};